import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ReactiveFormsModule } from "@angular/forms";
import { StaticDataType } from "@ankaadia/graphql";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { BehaviorSubject, filter, startWith } from "rxjs";
import { NewUiProfessionSelectorComponent } from "../../features/profession/profession-selector/new-ui-profession-selector.component";
import { NewUiWrapperReadonlyComponent } from "../../shared/form/wrapper-readonly/new-ui-wrapper-readonly.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { IsFilledByAIPipe, IsSuggestedPipe } from "../../shared/pipes/has-form-errors.pipe";
import { StaticDataPipe } from "../../shared/static-data/static-data.pipe";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-profession-selector",
  templateUrl: "./new-ui-formly-profession-selector.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NewUiProfessionSelectorComponent,
    FormlyModule,
    ReactiveFormsModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    Message,
    StaticDataPipe,
    AsyncPipe,
    NewUiWrapperReadonlyComponent,
    IsSuggestedPipe,
    IsFilledByAIPipe,
  ],
})
export class NewUiFormlyProfessionSelectorComponent extends FieldType implements OnInit {
  protected readonly StaticDataType = StaticDataType;

  constructor(private readonly destroyRef: DestroyRef) {
    super();
  }

  ngOnInit(): void {
    if (this.to?.useRootProfessionAsValue) this.setupValueOnFormStateProfessionChange();
  }

  private setupValueOnFormStateProfessionChange(): void {
    (<BehaviorSubject<string>>this.formState.profession)
      .pipe(
        startWith(<BehaviorSubject<string>>this.formState?.profession?.value),
        takeUntilDestroyed(this.destroyRef),
        filter((value) => this.field.formControl.value !== value)
      )
      .subscribe((value) => this.field.formControl.setValue(value));
  }
}
